import React, { useState, useEffect, useRef } from 'react';
import { Get_type_code_options, Get_today_range, Get_yesterday_range, Get_this_week_range, Get_last_week_range, Get_this_month_range } from '../Comun';

import '../FilterModal.css';

interface FilterModalProps {
    isOpen: boolean;
    onClose: () => void;
    onApplyFilters: (filters: {
        name: string | null;
        id_provider: number | null;
        start_dt: string | null;
        end_dt: string | null;
    }) => void;
    onClearFilters: () => void;
    providers: { id: number; name: string }[];
    currentFilters: {
        name: string | null;
        id_provider: number | null;
        start_dt: string | null;
        end_dt: string | null;
    };
}

const FilterCodigoModal: React.FC<FilterModalProps> = ({
    isOpen,
    onClose,
    onApplyFilters,
    onClearFilters,
    providers,
    currentFilters }) =>
{
    const [name, setName] = useState<string | null>(currentFilters.name);
    const [idProvider, setIdProvider] = useState<number | null>(currentFilters.id_provider);
    const [startDT, setStartDT] = useState<string | null>(currentFilters.start_dt);
    const [endDT, setEndDT] = useState<string | null>(currentFilters.end_dt);
    const [dateRange, setDateRange] = useState<string>('--Todas las fechas--');
    const modalRef = useRef<HTMLDivElement>(null);

    const typeOptions = Get_type_code_options();

    useEffect(() =>
    {
        if (isOpen)
        {
            setName(currentFilters.name);
            setIdProvider(currentFilters.id_provider);
            setStartDT(currentFilters.start_dt);
            setEndDT(currentFilters.end_dt);

            if (currentFilters.start_dt === null && currentFilters.end_dt === null)
            {
                setDateRange('--Todas las fechas--');
            }
            else if (currentFilters.start_dt && currentFilters.end_dt)
            {
                let start_dt: string | null = null;
                let end_dt: string | null = null;

                ({ start_dt, end_dt } = Get_today_range());
                if (start_dt === currentFilters.start_dt && end_dt === currentFilters.end_dt)
                {
                    setDateRange('Hoy');
                }
                else
                {
                    ({ start_dt, end_dt } = Get_yesterday_range());
                    if (start_dt === currentFilters.start_dt && end_dt === currentFilters.end_dt)
                    {
                        setDateRange('Ayer');
                    }
                    else
                    {
                        ({ start_dt, end_dt } = Get_this_week_range());
                        if (start_dt === currentFilters.start_dt && end_dt === currentFilters.end_dt)
                        {
                            setDateRange('Esta semana');
                        }
                        else
                        {
                            ({ start_dt, end_dt } = Get_last_week_range());
                            if (start_dt === currentFilters.start_dt && end_dt === currentFilters.end_dt)
                            {
                                setDateRange('Semana pasada');
                            }
                            else
                            {
                                ({ start_dt, end_dt } = Get_this_month_range());
                                if (start_dt === currentFilters.start_dt && end_dt === currentFilters.end_dt)
                                {
                                    setDateRange('Este mes');
                                }
                                else
                                {
                                    setDateRange('Personalizado');
                                }
                            }
                        }
                    }
                }
            }
            else
            {
                setDateRange('Personalizado');
            }
        }
    }, [isOpen, currentFilters]);

    useEffect(() =>
    {
        const handleClickOutside = (event: MouseEvent) =>
        {
            if (modalRef.current && !modalRef.current.contains(event.target as Node))
                onClose();
        };

        const handleEscPress = (event: KeyboardEvent) =>
        {
            if (event.key === 'Escape')
                onClose();
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscPress);

        return () =>
        {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscPress);
        };
    }, [onClose]);

    //-----------------------------------------------------------

    useEffect(() =>
    {
        let start_dt: string | null = null;
        let end_dt: string | null = null;

        switch (dateRange)
        {
            case '--Todas las fechas--':
                setStartDT(null);
                setEndDT(null);
                break;
            case 'Hoy':
                ({ start_dt, end_dt } = Get_today_range());
                break;
            case 'Ayer':
                ({ start_dt, end_dt } = Get_yesterday_range());
                break;
            case 'Esta semana':
                ({ start_dt, end_dt } = Get_this_week_range());
                break;
            case 'Semana pasada':
                ({ start_dt, end_dt } = Get_last_week_range());
                break;
            case 'Este mes':
                ({ start_dt, end_dt } = Get_this_month_range());
                break;
            case 'Personalizado':
                start_dt = currentFilters.start_dt;
                end_dt = currentFilters.end_dt;
                break;
            default:
                setStartDT(null);
                setEndDT(null);
        }

        if (start_dt !== null && end_dt !== null)
        {
            setStartDT(start_dt);
            setEndDT(end_dt);
        }
    }, [dateRange, currentFilters.start_dt, currentFilters.end_dt]);

    const handleApplyFilters = () =>
    {
        onApplyFilters({
            name,
            id_provider: idProvider,
            start_dt: startDT,
            end_dt: endDT
        });
        onClose();
    };

    const handleClearFilters = () =>
    {
        setName(null);
        setIdProvider(null);
        setStartDT(null);
        setEndDT(null);
        setDateRange('--Todas las fechas--');
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" ref={modalRef}>
                <h2>Filtrar eventos</h2>
                <form>

                    {/* Código */}
                    <div className="form-group">
                        <input
                            type="text"
                            value={name || ''}
                            placeholder="Todos los eventos"
                            onChange={(e) => setName(e.target.value || null)}
                        />
                    </div>
                    
                    {/* Proveedor */}
                    <div className="form-group">
                        <select
                            value={idProvider !== null ? idProvider : ''}
                            onChange={(e) => setIdProvider(e.target.value ? Number(e.target.value) : null)}
                        >
                            <option value="">Todos los proveedores</option>
                            {providers.map(provider => (
                                <option key={provider.id} value={provider.id}>
                                    {provider.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Rango de fechas */}
                    <div className="form-group">
                        <select
                            value={dateRange}
                            onChange={(e) => setDateRange(e.target.value)}
                        >
                            <option value="--Todas las fechas--">Todas las fechas</option>
                            <option value="Hoy">Hoy</option>
                            <option value="Ayer">Ayer</option>
                            <option value="Esta semana">Esta semana</option>
                            <option value="Semana pasada">Semana pasada</option>
                            <option value="Este mes">Este mes</option>
                            <option value="Personalizado">Personalizado</option>
                        </select>
                    </div>

                    {/* Fechas personalizadas */}
                    <div className={`form-group date-range-container ${dateRange !== 'Personalizado' ? 'hidden' : ''}`}>
                        <input
                            type="date"
                            value={startDT || ''}
                            onChange={(e) => setStartDT(e.target.value || null)}
                        />
                        <input
                            type="date"
                            value={endDT || ''}
                            onChange={(e) => setEndDT(e.target.value || null)}
                        />
                    </div>

                    {/* Acciones */}
                    <div className="modal-actions">
                        <button type="button" className="delete-filter-button" onClick={handleClearFilters}>
                            Borrar filtros
                        </button>
                        <div className="modal-actions-right">
                            <button type="button" className="filter-button" onClick={onClose}>Cancelar</button>
                            <button type="button" className="filter-button2" onClick={handleApplyFilters}>Aplicar</button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default FilterCodigoModal;